import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';

import store from '@/store';

export interface IAppInfoState {
  version: string | null;
  envName: string | null;
}

@Module({
  dynamic: true,
  name: 'appInfo',
  store,
})
export class AppInfoModule extends VuexModule implements IAppInfoState {
  public version: string | null = null;
  public envName: string | null = null;

  @Mutation
  public updateAppInfo(appInfo: IAppInfoState): void {
    this.version = appInfo.version;
    this.envName = appInfo.envName;
  }

  @Action({ commit: 'updateAppInfo' })
  public setAppInfo(appInfo: IAppInfoState) {
    return appInfo;
  }
}
export default getModule(AppInfoModule);
